import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GraphqlService } from '../graphql/graphql.service';
import {
	AUTH_TOKEN,
	GET_CURRENT_USER_QUERY,
	SEND_EMAIL_FOR_RESET_PASSWORD,
	VERIFY_RESET_TOKEN,
	CHANGE_PASSWORD_WITH_TOKEN
} from './auth.queries';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from './../../common/interfaces/user';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	AUTH_TOKEN = AUTH_TOKEN;
	GET_CURRENT_USER_QUERY = GET_CURRENT_USER_QUERY;
	SEND_EMAIL_FOR_RESET_PASSWORD = SEND_EMAIL_FOR_RESET_PASSWORD;
	VERIFY_RESET_TOKEN = VERIFY_RESET_TOKEN;
	CHANGE_PASSWORD_WITH_TOKEN = CHANGE_PASSWORD_WITH_TOKEN;

	private currentUserSubject: BehaviorSubject<User>;
	public currentUser: Observable<User>;

	constructor(private graphqlService: GraphqlService, private router: Router) {
		if (localStorage.getItem('currentUser')) {
			this.currentUserSubject = new BehaviorSubject<User>(
				JSON.parse(localStorage.getItem('currentUser'))
			);
		} else {
			this.currentUserSubject = new BehaviorSubject<User>(null);
		}

		this.currentUser = this.currentUserSubject.asObservable();
	}

	public get currentUserValue(): User {
		return this.currentUserSubject.value;
	}

	login(formData) {
		return this.graphqlService.apollo.mutate({
			mutation: this.AUTH_TOKEN,
			variables: {
				email: formData.email,
				password: formData.password
			}
		});
	}

	getCurrentUser() {
		return this.graphqlService.apollo
			.watchQuery<any>({
				query: this.GET_CURRENT_USER_QUERY
			})
			.valueChanges.subscribe(
				result => {
					localStorage.setItem(
						'currentUser',
						JSON.stringify(result['data']['me'])
					);
					this.currentUserSubject.next(result.data['me']);

					this.router.navigate(['/scenario-one']);
				},
				error => {
					console.log(error);
				}
			);
	}

	// forgot-password
	sendEmailForReset(formData) {
		return this.graphqlService.apollo.mutate({
			mutation: this.SEND_EMAIL_FOR_RESET_PASSWORD,
			variables: {
				email: formData.email,
				typeApp: 2
			}
		});
	}

	// reset-password
	verifyResetToken(guidToken: string) {
		return this.graphqlService.apollo.mutate({
			mutation: this.VERIFY_RESET_TOKEN,
			variables: {
				guid: guidToken
			}
		});
	}

	changePasswordWithToken(formData, user, token) {
		return this.graphqlService.apollo.mutate({
			mutation: this.CHANGE_PASSWORD_WITH_TOKEN,
			variables: {
				email: user.email,
				guid: token,
				newPassword: formData.password
			}
		});
	}

	logout() {
		this.router.navigate(['/login']);
		localStorage.removeItem('currentUser');
		localStorage.removeItem('token');
		this.currentUserSubject.next(null);
		this.graphqlService.apollo.getClient().clearStore();
	}
}
